module.exports = __webpack_public_path__ + "static/media/boxChat.95d5a697.svg";